import { render } from "./BaseBox.vue?vue&type=template&id=297fa128&scoped=true"
import script from "./BaseBox.vue?vue&type=script&lang=js"
export * from "./BaseBox.vue?vue&type=script&lang=js"

import "./BaseBox.vue?vue&type=style&index=0&id=297fa128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297fa128"]])

export default __exports__